import { component } from 'picoapp'
import scroll from 'scrollmonitor'

export default component(({ node: img }) => {

  scroll.create(img).enterViewport(() => {
    img.onload = e => img.classList.add('is-loaded')
    img.src = img.getAttribute('data-src')
    setTimeout(() => {
      img.classList.add('is-visible')
    }, 500)
  })
})
